import { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../hooks/useAuth';
import { useEnv } from '../../../../context/env-context';
import { makeRequest } from '../../../../utils/makeRequest';

function FundingsRedFlagsFilterForm({ flagsFilter, changeFlagsFilter, spinner }) {
  const { apiOriginFunding } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [flags, setFlags] = useState([]);

  const getFlags = async () => {
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = { token, url: `${apiOriginFunding}/get_all_flags`, method: 'GET' };

    try {
      const data = await makeRequest(config);

      setFlags(Object.entries(data));
    } catch (error) {
      toast.error(`Failed getting advance flags: ${error.message}`);
    }
  };

  useEffect(() => {
    getFlags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form.Select
      className="bo-filter bo-min-w-240"
      name="flagsFilter"
      id="flagsFilter"
      disabled={spinner}
      value={flagsFilter}
      onChange={e => changeFlagsFilter('fundings', e.target.value)}
    >
      <option value="">Ignore Flags</option>
      <option value={flags.map(([key]) => key).join(',')}>Any Flag</option>
      {flags.map(([key, value]) => (
        <option key={key} value={key}>
          {value}
        </option>
      ))}
    </Form.Select>
  );
}

export default FundingsRedFlagsFilterForm;
